/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.myCode = function () {

  }

  growApp.prototype.toggleDisplay = function () {
    const displayAllBtn = $(".js-display-all");
    const displayAllData = $(".js-display-data");
    const displayBtn = $(".js-display-btn");
    const displayAllBlock = $('.js-display-block');

    const btnTexts = {
      Allopen: "全ての性能仕様を表示",
      Allclose: "全ての性能仕様を閉じる",
      open: "性能仕様を表示",
      close: "性能仕様を閉じる"
    }

    // All
    displayAllBtn.click(function () {



      if (displayAllBtn.hasClass("is-open")) {
        displayAllData.slideUp("normal");
        displayAllBtn.html(btnTexts.Allopen);
        displayAllBtn.toggleClass("is-open");
        displayBtn.html(btnTexts.open);
        displayAllBlock.removeClass("is-open");
      } else {
        displayAllData.slideDown("normal");
        displayAllBtn.html(btnTexts.Allclose);
        displayAllBtn.toggleClass("is-open");
        displayBtn.html(btnTexts.close);
        displayAllBlock.addClass("is-open");
      }
    })

    // Just one
    displayBtn.click(function() {
      const block = $(this).closest('.js-display-block');
      const data = block.find('.js-display-data');
      if (block.hasClass("is-open")) {
        data.slideUp("normal");
        $(this).html(btnTexts.open);
        block.toggleClass("is-open");
      } else {
        data.slideDown("normal");
        $(this).html(btnTexts.close);
        block.toggleClass("is-open");
      }
    })
  }

  $(function () {
    var app = new growApp();
    app.myCode();
    app.toggleDisplay();
  });
})(jQuery);
